export default "__VITE_ASSET__DYBFmdOY__"